<template>
  <div class="has-text-right is-flex-grow-2">
    <span class="is-size-5 has-text-grey">
      {{ $t("checkout.cart.isFullPrice") }}:
    </span>
    <span class="title is-4 has-text-black px-3">
      <template v-if="pricing.printable">
        {{ netPrice | toCents | currency }}
      </template>
      <template class="item--color__price" v-else>{{
        null | currency
      }}</template>
    </span>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { eventBus } from "../../../events/event-bus";
import axios from "axios";

export default {
  name: "SelectedPrice",
  computed: {
    ...mapGetters([
      "currentCartItem",
      "current3DFile",
      "taxRate",
      "isBusinessCustomer",
      "printQualityInfo",
    ]),
    pricing() {
      if (this.printQualityInfo) {
        return this.printQualityInfo.printabilityForSelected;
      } else {
        return {
          price: 0,
          productionTimeDays: 0,
          isPrintable: true,
          tooLarge: false,
          tooSmall: false,
        };
      }
    },
    netPrice() {
      return this.pricing.price.netPrice;
    },
  },
};
</script>

<style scoped lang="scss">
</style>